export const formInitialValues = (data) => ({
  namaItem: data?.nama_item_sumber_daya ?? "",
  namaKategori: data?.nama_kategori_anggaran ?? "",
  idItemSumberDaya: data?.id_item_sumber_daya ?? "",
  noCoa: data?.noCoa ?? "",
  namaCoa: data?.nama_akun ?? "",
});
